import type { PivotExpandState, PivotNode } from './types'
import { isPivotExpanded } from './isPivotExpanded'

// A collapsed group hides its whole subtree, so the walk stops at a collapsed group and never
// descends into it — one collapsed group counts once no matter how its children are set.
/** True when any shown group row under the node is collapsed. */
export const hasCollapsedPivotRow = ({
  node,
  depth,
  expandState,
}: {
  node: PivotNode
  depth: number
  expandState: PivotExpandState
}): boolean =>
  node.children.some(
    (child) =>
      child.depth < depth &&
      (!isPivotExpanded(expandState, child.key) || hasCollapsedPivotRow({ node: child, depth, expandState }))
  )
